import { useTranslation } from "i18n";
import { Button } from "ui";

interface ReturnToAppButtonProps {
  url: string;
}

/**
 * Takes the place of the Pay button once a confirmed payment's automatic
 * redirect back to the app has been blocked — Chrome won't hand a
 * custom-scheme URL to an app without a user gesture, so the payer would
 * otherwise sit in the Custom Tab watching a spinner. Tapping this is that
 * gesture.
 *
 * An anchor rather than an onClick handler: the handoff should be the browser's
 * own handling of the tap, since that is the gesture Chrome is holding out for.
 * The success page's "Go back" button (PaymentSuccess.tsx) hands over the same
 * `onSuccessUrl` and is an anchor for the same reason.
 *
 * Reaching this is proof of payment as far as the app is concerned, so it must
 * only ever render off the store flag that redirectWithReturnFallback sets —
 * never speculatively.
 */
export const ReturnToAppButton = ({ url }: ReturnToAppButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button as="a" href={url} size="lg" block>
      {t("Purchase complete - return to the app")}
    </Button>
  );
};
